import { HorizontalSafeAreaContainer } from '../../../components';
import { CreditDetailsScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <CreditDetailsScreen />
    </HorizontalSafeAreaContainer>
  );
}
